{
  "common": {
    "save": "Guardar",
    "cancel": "Cancelar",
    "delete": "Eliminar",
    "edit": "Editar",
    "create": "Crear",
    "loading": "Cargando...",
    "saving": "Guardando...",
    "search": "Buscar",
    "confirm": "Confirmar"
  },
  "sidebar": {
    "dashboard": "Panel",
    "users": "Usuarios",
    "brands": "Tiendas",
    "categories": "Categorías",
    "institutions": "Instituciones",
    "transactions": "Transacciones",
    "donations": "Donaciones",
    "coupons": "Cupones",
    "sync": "Sincronización",
    "integrations": "Integraciones",
    "blog": "Blog",
    "marketing": "Marketing",
    "international": "Internacional",
    "localization": "Localización"
  },
  "toasts": {
    "saved": "Cambios guardados con éxito.",
    "error": "Algo salió mal. Inténtalo de nuevo."
  },
  "localization": {
    "title": "Localización",
    "description": "Define el idioma del sitio público y tu idioma del panel.",
    "publicSiteLanguage": "Idioma del sitio (público global)",
    "publicSiteLanguageHelp": "Idioma mostrado a los visitantes. Afecta a todo el sitio público.",
    "dashboardLanguage": "Idioma de mi panel",
    "dashboardLanguageHelp": "Solo para tu cuenta. No afecta al sitio público ni a otros administradores.",
    "savePublic": "Guardar idioma público",
    "saveDashboard": "Guardar mi idioma",
    "publicSaved": "Idioma público actualizado.",
    "dashboardSaved": "Tu idioma del panel se actualizó."
  }
}